<template>
  <div class="container service-panel">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="row" v-if="errorMessage && !isLoading">
      <div class="col-md-12 col-12">
        <div class="fade-in-out alert alert-error">
          <div>{{errorMessage}}</div>
        </div>
      </div>
    </div>
    <div v-if="platformCategory">
      <browse-standard-service
        v-if="platformCategory == 'HR'"
        :key="componentKey"
        :platform-category="platformCategory"
        :platform-category-name="platformCategoryName"
        :category-id="categoryId ? categoryId : serviceId"
      ></browse-standard-service>
      <browse-service-taxonomy-service
        v-else
        :platform-category="platformCategory"
        :platform-category-name="platformCategoryName"
        :category-id="categoryId"
        :service-id="serviceId"
      ></browse-service-taxonomy-service>
    </div>
  </div>
</template>

<script>
import { safeImportComponent } from "@/utils/componentImportUtils";
import { mapActions, mapGetters } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay";
import * as CONSTANTS from "@/store/constants";
import BrowseServiceTaxonomyService from "@/components/service-browser/BrowseServiceTaxonomyService.vue";
import BrowseStandardService from "@/components/service-browser/BrowseStandardService.vue";
import router from "../../router";
export default {
  data() {
    return {
      platformCategory: undefined,
      platformCategoryName: undefined,
      categoryId: undefined,
      serviceId: undefined,
      componentKey: 0
    };
  },
  components: {
    BrowseServiceTaxonomyService,
    BrowseStandardService,
    LoadingOverlay
  },
  computed: {
    ...mapGetters([
      "platformCategories",
      "isLoading",
      "errorMessage",
      "country",
      "user",
      "standardContentAccessible"
    ])
  },
  watch: {
    "user.userName": function() {
      this.fetchPlatformCategories().then(() => {
        this.init();
      });
      this.componentKey++;
    },
    country: function() {
      this.init();
      this.componentKey++;
    }
  },
  created() {
    let that = this;

    safeImportComponent(HH_COMPONENTS_URL + "/helphubservice.umd.min.js");

    this.fetchPlatformCategories().then(() => {
      that.init();
    });
  },
  methods: {
    ...mapActions(["fetchPlatformCategories", "setBannerErrorMessage"]),
    init() {
      if (this.$route.params.platformCategory) {
        let platform = this.$route.params.platformCategory.toUpperCase();

        let platformObj = this.platformCategories.find(
          item => item.alias === platform
        );

        if (!platformObj) {
          this.setBannerErrorMessage(CONSTANTS.INVALID_PLATFORM);
          return;
        } else {
          this.platformCategory = platform;
          this.platformCategoryName = platformObj.name;
        }

        // If STANDARD type and not accessible give a forbidden page
        if (platformObj.type == "STANDARD" && !this.standardContentAccessible) {
          router.push({ name: "Forbidden" });
        }
      }

      this.categoryId = this.$route.params.id;
      this.serviceId = this.$route.params.serviceId;
    }
  }
};
</script>

<style scoped>
.service-panel {
  background: #ffffff;
  min-height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/service-browser/BrowseService.vue